export default {
    PreviousText: "前へ",
    NextText: "次へ",
    LoadingText: "準備中。。。",
    NoDataText: "データが存在しません。",
    RowsText: "行"
}